import { useState } from 'react';
import { useDispatch, useReduxState } from 'hooks';
import api from 'api';
import { actions } from 'store';
import { ModalButtonWithForm } from 'components/common';
import { AmbitionsSelector } from 'components/common/form';

interface Props {
  ambitions: string[];
  targetUserId: number;
  updateAmbitions: () => Promise<void>;
}

const ProfileAmbitionsEdit = ({
  ambitions,
  targetUserId,
  updateAmbitions
}: Props) => {
  const { dispatch } = useDispatch();

  const {
    messages,
    pageState: { user }
  } = useReduxState();

  const [fetchData, setFetchData] = useState(false);

  const handleSubmit = async (values: { ambitions: string[] }) => {
    try {
      const response = await api.put(`/admin/users/${targetUserId}/ambitions`, {
        ambitions: values.ambitions || []
      });
      dispatch(
        actions.addNotice({
          text: messages.profileEditProfileAmbitionsSuccess,
          type: 'success'
        })
      );

      if (response.data?.success) {
        await updateAmbitions();
      }

      return true;
    } catch (err) {
      await dispatch.handleErrorDispatch(err);
    }
  };

  return (
    <ModalButtonWithForm
      buttonCategory="lighter"
      buttonIcon="pen"
      buttonProps={{
        iconStyle: {
          fontSize: '1rem',
          marginRight: 5,
          position: 'relative',
          top: -1
        }
      }}
      buttonSize="header"
      buttonText={messages.commonEdit}
      initialValues={{ ambitions }}
      modalActionCategory="success"
      modalActionText={messages.commonSave}
      modalTitle={messages.profileEditProfileAmbitions}
      modalWidth="medium"
      onHide={() => setFetchData(false)}
      onShow={() => setFetchData(true)}
      onSubmit={handleSubmit}
      pristineIsValid={false}
    >
      {() => (
        <AmbitionsSelector
          maxWidth="100%"
          onlyIf={fetchData}
          title={messages.commonUserAmbitions}
        />
      )}
    </ModalButtonWithForm>
  );
};

export default ProfileAmbitionsEdit;
